import { Component, Input } from '@angular/core';
import { Product } from '../../../models/product';

@Component({
  selector: 'span[app-product-price]',
  imports: [],
  templateUrl: './product-price.html',
  styleUrl: './product-price.scss',
})
export class ProductPrice {
  @Input({ required: true }) data!: Product;

  get price(): string {
    var lower = Number.MAX_VALUE;
    var upper = 0;

    if (this.data.priced_attr) {
      for (const value of this.data.priced_attr.values) {
        if (value.price > upper) {
          upper = value.price;
        }
        if (value.price < lower) {
          lower = value.price;
        }
      }
      if (lower > upper) {
        return '';
      } else if (lower === upper) {
        return `${lower}`;
      }
      return `${lower} - ${upper}`;
    }
    return '';
  }
}
